module.exports = __webpack_public_path__ + "static/media/airship.38d26110.glb";